import React from "react";
import { TableRow, TableCell, IconButton, Icon } from "@mui/material";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TranslateIcon from '@mui/icons-material/Translate';
import MicIcon from '@mui/icons-material/Mic';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import BookmarkRemoveIcon from '@mui/icons-material/BookmarkRemove';
import { Link } from "react-router-dom";
import type { ContextNode } from "../services/brainflex/NodesServiceClient";
import "./NodeItem.css";

interface NodeItemProps {
  node: ContextNode;
  languageSelection: { language: string; locale: string; voice: string };
  playButtonRef: (el: HTMLButtonElement | null) => void;
  audioRef: (el: HTMLAudioElement | null) => void;
  onTranslate: (nodeId: number, language: string) => void;
  onSpeak: (nodeId: number, language: string, locale: string, voice: string) => void;
  onPlay: (nodeId: number, language: string, locale: string, voice: string) => void;
  onAudioPlayed: (nodeId: number, locale: string, voice: string) => void;
  onBookmark: (nodeId: number, locale: string, voice: string, isBookmarked: boolean) => void;
}

const NodeItem: React.FC<NodeItemProps> = ({
  node,
  languageSelection,
  playButtonRef,
  audioRef,
  onTranslate,
  onSpeak,
  onPlay,
  onAudioPlayed,
  onBookmark,
}) => (
  <TableRow className="node-row">
    <TableCell>{node.id}</TableCell>
    <TableCell>{node.name}</TableCell>
    <TableCell>
      {node.targetNodeText ? (
        node.targetNodeText.text
      ) : (
        <IconButton aria-label="play" onClick={() => onTranslate(node.id, languageSelection.language)}>
          <TranslateIcon />
        </IconButton>
      )}
    </TableCell>
    <TableCell>
      {!node.targetNodeText ? (
        <span>&nbsp;</span>
      ) : !node.targetNodeSpeech ? (
        <IconButton aria-label="record" onClick={() => onSpeak(node.id, languageSelection.language, languageSelection.locale, languageSelection.voice)}>
          <MicIcon />
        </IconButton>
      ) : (
        <div className="node-audio-row">
          <IconButton ref={playButtonRef} aria-label="play" onClick={() => onPlay(node.id, languageSelection.language, languageSelection.locale, languageSelection.voice)}>
            <Icon>play_arrow</Icon>
          </IconButton>
          <audio
            className="speechAudio"
            ref={audioRef}
            controls
            onPlay={() => onAudioPlayed(node.id, languageSelection.locale, languageSelection.voice)}
          >
            <source type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>
        </div>
      )}
    </TableCell>
    <TableCell>
      {node.targetNodeSpeech ? (
        node.bookmarkedAt ? (
          <IconButton aria-label="remove bookmark" onClick={() => onBookmark(node.id, languageSelection.locale, languageSelection.voice, false)}>
            <BookmarkRemoveIcon />
          </IconButton>
        ) : (
          <IconButton aria-label="add bookmark" onClick={() => onBookmark(node.id, languageSelection.locale, languageSelection.voice, true)}>
            <BookmarkAddIcon />
          </IconButton>
        )
      ) : null}
    </TableCell>
    <TableCell>
      <IconButton aria-label="navigate" component={Link} to={`/nodes/${node.id}`}>
        <ChevronRightIcon />
      </IconButton>
    </TableCell>
  </TableRow>
);

export default NodeItem;
